export const ModalArchiveLists = ({isCloseModalOpen, actionTargetType, modalRef, closeModal, handleRestoreList, currentAction, handleConfirmAction}) => {
    return (
        <>
            {isCloseModalOpen && actionTargetType === "list" && (
                <div className="closeBoardModalOverlay">
                    <div className="closeBoardModal" ref={modalRef}>
                        <div className="closeBoardModal__header">
                            <h3>{currentAction.title}</h3>
                            <button
                                type="button"
                                className="closeBoardModal__close"
                                onClick={closeModal}
                            >
                                ✕
                            </button>
                        </div>

                        <div className="closeBoardModal__body">
                            <p>{currentAction.text}</p>
                        </div>

                        <button
                            type="button"
                            className="closeBoardModal__danger"
                            onClick={handleConfirmAction}
                        >
                            {currentAction.buttonText}
                        </button>
                    </div>
                </div>
            )}
        </>
    )
}